import { useQuery } from '@tanstack/react-query';
import type { ForecastBundle } from '@heat-pwa/types';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';
const ONE_HOUR_MS = 60 * 60 * 1000;

async function fetchForecasts(): Promise<ForecastBundle> {
  const res = await fetch(`${API_BASE}/api/forecasts`);
  if (!res.ok) throw new Error(`forecasts fetch failed: ${res.status}`);
  return (await res.json()) as ForecastBundle;
}

export function useForecastsQuery() {
  return useQuery({
    queryKey: ['forecasts', 'all'],
    queryFn: fetchForecasts,
    staleTime: ONE_HOUR_MS,
    refetchOnWindowFocus: false,
  });
}
